import { render, staticRenderFns } from "./LiveWorkStats.vue?vue&type=template&id=42f368f8&scoped=true"
import script from "./LiveWorkStats.vue?vue&type=script&lang=js"
export * from "./LiveWorkStats.vue?vue&type=script&lang=js"
import style0 from "./LiveWorkStats.vue?vue&type=style&index=0&id=42f368f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f368f8",
  null
  
)

export default component.exports